import { mapControl } from '@/constants';
/**
 * bounds 객체 관리
 */
export default class Bounds {
    // eslint-disable-next-line no-use-before-define
    static instance = null;
    naver;
    mapInstance;
    bounds;
    boundsInside;
    boundsOutside;
    extendPixel;
    reducePixel;
    INSIDE = mapControl.mapBoundary.INSIDE;
    OUTSIDE = mapControl.mapBoundary.OUTSIDE;
    ORIGIN = mapControl.mapBoundary.ORIGIN;
    static getInstance(naver, map) {
        if (Bounds.instance == null) {
            Bounds.instance = new Bounds();
            Bounds.instance.init(naver, map);
        }
        return this.instance;
    }
    constructor() {
        this.naver = null;
        this.mapInstance = null;
        /** 영역 오리진 */
        this.bounds = null;
        /** 안쪽 영역 */
        this.boundsInside = null;
        /** 바깥쪽 영역 */
        this.boundsOutside = null;
        /** 확장될 bounds 픽셀 */
        this.extendPixel = mapControl.EXTEND_SIZE;
        /** 축소시킬 영역 */
        this.reducePixel = mapControl.REDUCE_SIZE;
    }
    /**
     * 지도 bounds 영역 확장
     * @param naver 네이버 객체
     * @param pixel 변경 픽셀
     * @returns 확장된 bounds 영역
     */
    _getProjectionBounds(mapBounds, projection, value = false) {
        const sw = mapBounds.getSW();
        const ne = mapBounds.getNE();
        // 남서
        const offsetSW = projection.fromCoordToOffset(sw);
        // 북동
        const offsetNE = projection.fromCoordToOffset(ne);
        if (value) {
            offsetSW.x -= value;
            offsetSW.y += value;
            offsetNE.x += value;
            offsetNE.y -= value;
        }
        return new this.naver.maps.LatLngBounds(projection.fromOffsetToCoord(offsetSW), projection.fromOffsetToCoord(offsetNE));
    }
    /**
     * bounds 호출
     */
    getBounds(type = this.ORIGIN) {
        switch (type) {
            case this.INSIDE: return this.boundsInside;
            case this.OUTSIDE: return this.boundsOutside;
            case this.ORIGIN: return this.bounds;
            default: return null;
        }
    }
    /**
     * bounds 업데이트
     */
    updateBounds() {
        const mapBounds = this.mapInstance.getBounds();
        const projection = this.mapInstance.getProjection();
        this.bounds = this._getProjectionBounds(mapBounds, projection);
        this.boundsInside = this._getProjectionBounds(mapBounds, projection, this.reducePixel);
        this.boundsOutside = this._getProjectionBounds(mapBounds, projection, this.extendPixel);
    }
    /**
     * 현 영역에 포함되는지 여부
     * @param position getBounds 리턴값
     * @param boundaryType 경계 타입
     * @returns
     */
    hasBounds(position, boundaryType = this.ORIGIN) {
        switch (boundaryType) {
            case this.INSIDE: return this.boundsInside.hasLatLng(position);
            case this.OUTSIDE: return this.boundsOutside.hasLatLng(position);
            case this.ORIGIN: return this.bounds.hasLatLng(position);
            default: return null;
        }
    }
    /**
     * 초기화
     */
    init(naver, mapInstance) {
        this.naver = naver;
        this.mapInstance = mapInstance;
    }
}
